import styled from "styled-components";

export const ReferenceLink = styled.a`
  color: black;
  text-decoration: underline;
`;
